import { render, staticRenderFns } from "./simple-button-group.vue?vue&type=template&id=fa46c2aa&scoped=true&"
import script from "./simple-button-group.vue?vue&type=script&lang=js&"
export * from "./simple-button-group.vue?vue&type=script&lang=js&"
import style0 from "./simple-button-group.vue?vue&type=style&index=0&id=fa46c2aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa46c2aa",
  null
  
)

export default component.exports